import { DynamoClient } from '../abstractClient';
import { LabeledDataClient } from '../labeledData/labeledDataClient';
import { DEPolicyType } from './examplePoliciesClient.types';
import { LabeledDataPolicyResponse } from '../labeledData/labeledDataClient.types';
import { TableName } from '../types';

export class ExamplePoliciesClient extends DynamoClient {
  tableName = 'policy_examples';
  labeledDataClient: LabeledDataClient;
  constructor(dbConfig: {
    region: string;
    credentials: {
      secretAccessKey: string;
      accessKeyId: string;
    };
  }) {
    super(dbConfig);
    this.labeledDataClient = new LabeledDataClient({
      dbConfig,
      tableName: TableName.LabeledData,
    });
  }

  async getExamplePolicies(
    carrierSlug: string,
    policyType: DEPolicyType,
  ): Promise<LabeledDataPolicyResponse[]> {
    const input = {
      TableName: this.tableName,
      Key: {
        policyType,
        carrierSlug,
      },
    };

    const examples = await this.getItem(input);

    if (!examples) return [];

    return await Promise.all(
      examples.policyIds.map((policyId: string) =>
        this.labeledDataClient.getPolicyDetails(policyId),
      ),
    );
  }
}
